import { render, staticRenderFns } from "./BalanceDropdown.vue?vue&type=template&id=248e890e&scoped=true"
import script from "./BalanceDropdown.vue?vue&type=script&lang=js"
export * from "./BalanceDropdown.vue?vue&type=script&lang=js"
import style0 from "./BalanceDropdown.vue?vue&type=style&index=0&id=248e890e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248e890e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
